import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxParallaxModule } from '@yoozly/ngx-parallax';
import { NgxScrollTopModule } from 'ngx-scrolltop';
import { NgCircleProgressModule } from 'ng-circle-progress';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarComponent } from './components/common/navbar/navbar.component';
import { FooterComponent } from './components/common/footer/footer.component';

import { HomeSevenComponent } from './components/pages/home-seven/home-seven.component';

import { BlogComponent } from './components/pages/blog/blog.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { CountersComponent } from './components/pages/counters/counters.component';
import { CountdownsComponent } from './components/pages/countdowns/countdowns.component';

import { PricingsComponent } from './components/pages/pricings/pricings.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { ComingSoonComponent } from './components/pages/coming-soon/coming-soon.component';
import { ShowCaseComponent } from './components/pages/show-case/show-case.component';
import { RhillaneComponent } from './components/pages/websites/rhillane.component';
import { PubliciteComponent } from './components/pages/publicite/publicite.component';
import { ReseauxSociauxComponent } from './components/pages/reseaux-sociaux.component';
import { DesignGraphiqueComponent } from './components/pages/design-graphique.component';
import { SeoAgenceComponent } from './components/pages/seo-agence.component';
import { AProposComponent } from './components/pages/apropos-nous.component';
import { ContactezNousComponent } from './components/pages/contactez-nous.component';
import { CguComponent } from './components/pages/cgu.component';
import { PolitiqueConfidentialiteComponent } from './components/pages/politique-confidentialite.component';
import { DevisComponent } from './components/pages/devis.component';
import { appwebComponent } from './components/pages/appweb/appweb.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,

    HomeSevenComponent,

    BlogComponent,
    BlogDetailsComponent,
    CountersComponent,
    CountdownsComponent,

    PricingsComponent,
    ErrorComponent,
    ComingSoonComponent,
    ShowCaseComponent,
    RhillaneComponent,
        PubliciteComponent,
    ReseauxSociauxComponent,
    DesignGraphiqueComponent,
    SeoAgenceComponent,
    AProposComponent,
    ContactezNousComponent,
    CguComponent,
    PolitiqueConfidentialiteComponent,
    DevisComponent,
    appwebComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule,
    NgxParallaxModule,
    BrowserAnimationsModule,
    NgxScrollTopModule,
    NgCircleProgressModule.forRoot({})
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    provideClientHydration()
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
